export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_FAIL = 'CREATE_EMPLOYEE_FAIL';
export const CREATE_EMPLOYEE_RESET = 'CREATE_EMPLOYEE_RESET';

export const CHANGE_EMPLOYEE_REQUEST = 'CHANGE_EMPLOYEE_REQUEST';
export const CHANGE_EMPLOYEE_SUCCESS = 'CHANGE_EMPLOYEE_SUCCESS';
export const CHANGE_EMPLOYEE_FAIL = 'CHANGE_EMPLOYEE_FAIL';
export const CHANGE_EMPLOYEE_RESET = 'CHANGE_EMPLOYEE_RESET';

export const GET_EMPLOYEES_REQUEST = 'GET_EMPLOYEES_REQUEST';
export const GET_EMPLOYEES_SUCCESS = 'GET_EMPLOYEES_SUCCESS';
export const GET_EMPLOYEES_FAIL = 'GET_EMPLOYEES_FAIL';